module.exports = __webpack_public_path__ + "static/media/icon.2e285701.svg";